import UrlParameter from "./UrlParameter";
export var NET = {
    UrlParameter: UrlParameter
};



//////////////////
// WEBPACK FOOTER
// ./src/fhl/net/ns.ts
// module id = null
// module chunks = 